import type { AuthUser } from '@/types/auth';
import type { IFolder } from '@/types/folder';

import { makeVar } from '@apollo/client';

import { IQrTotalCountInfo } from '@/types/entry';

export const currentFolderVar = makeVar<IFolder | null>(null);

export const currentUserVar = makeVar<AuthUser | null>(null);

export const qrTotalCountInfoVar = makeVar<IQrTotalCountInfo | null>(null);

export const showQrLimitWarningAlertVar = makeVar<boolean>(true);